import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
/**
 * Calls a defined callback function on each key:value of a object,
 * and returns a object contains the result.
 */
export function mapObject(object, callbackfn) {
  return Object.entries(object).reduce(function (obj, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    obj[key] = callbackfn(value, key, object);
    return obj;
  }, {});
}
export function indexOf(array) {
  return array.map(function (_, i) {
    return i;
  });
}
/**
 * @example [[1, 2, 3], ['a', 'b', 'c']] => [[1, 'a'], [2, 'b'], [3, 'c']]
 */
export function transpose(matrix) {
  var row = matrix.length;
  var col = matrix[0].length;
  // Note: new Array(col).fill(new Array(row)) is not ok!!!
  // Because in this case it will fill new Array(col) with the same array: new Array(row).
  var transposed = new Array(col).fill(0).map(function () {
    return new Array(row);
  });
  for (var i = 0; i < col; i++) {
    for (var j = 0; j < row; j++) {
      transposed[i][j] = matrix[j][i];
    }
  }
  return transposed;
}
export function firstOf(array) {
  return array[0];
}
export function lastOf(array) {
  return array[array.length - 1];
}
export function isFlatArray(array) {
  return !array.some(Array.isArray);
}
export function unique(array) {
  return Array.from(new Set(array));
}
export function divide(array, callbackfn) {
  var result = [[], []];
  array.forEach(function (item) {
    result[callbackfn(item) ? 0 : 1].push(item);
  });
  return result;
}
function comb(array) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : array.length;
  if (len === 1) return array.map(function (item) {
    return [item];
  });
  var result = [];
  var _loop = function _loop(i) {
    var rest = array.slice(i + 1);
    var restComb = comb(rest, len - 1);
    restComb.forEach(function (comb) {
      result.push([array[i]].concat(_toConsumableArray(comb)));
    });
  };
  for (var i = 0; i < array.length; i++) {
    _loop(i);
  }
  return result;
}
/**
 * get all combinations of two elements in an array
 * @example [1, 2, 3] => [[1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
 * @param array
 * @returns
 */
export function combine(array) {
  if (array.length === 1) return [array];
  var result = [];
  for (var i = 1; i <= array.length; i++) {
    result.push.apply(result, _toConsumableArray(comb(array, i)));
  }
  return result;
}